import ClientInvoiceAdminItem from '../../../Domain/ClientInvoiceAdminItem';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ReportRunnerService from '../../../Services/ReportRunnerSerivce';

export default class ExportSapReconciliationWindowDescription {
  static titleForCreate = 'Export SAP Reconciliation';
  static titleForEdit = 'Export SAP Reconciliation';
  static itemType = ClientInvoiceAdminItem;
  static serviceFunction = ReportRunnerService.RequestSapReconciliationReport;
  static waitForServiceFunction = () => false;
  static finishButtonLabel = 'Export';
  static messageOnSuccess =
    'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'FinalizedAfter',
          label: 'Finalized After',
          className: 'col-12',
          type: InputTypesEnum.DateWithIndefinite,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'FinalizedBefore',
          label: 'Finalized Before',
          className: 'col-12',
          type: InputTypesEnum.DateWithIndefinite,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
